import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import tradeDataStore from "@/store/tradeDataStore";
import { determineCounterparty, determineDirection } from "./directionHelpers";

/**
 * Pure formatting function for direction cell
 * Used by both valueFormatter (for copy/paste) and cellRenderer (for display)
 *
 * @param params - AG Grid cell params
 * @param currentTrade - The current trade from Zustand store (optional for valueFormatter)
 * @returns Formatted string with counterparty and direction
 */
export function formatDirectionValue(
  params: any,
  currentTrade?: ExecutionStrategy,
): string {
  const { isOp, isOutright, fullTradeData } =
    returnAllTradeDetailsFromGenericParams(params);

  const directionToReturn = determineDirection(
    params,
    currentTrade,
    isOp,
    isOutright,
  );

  const originatingCounterparty = determineCounterparty(
    currentTrade,
    isOp,
    isOutright,
    directionToReturn,
    fullTradeData,
  );

  return `${originatingCounterparty} ${directionToReturn}`.trim();
}

/**
 * AG Grid valueFormatter for copy/paste functionality
 * This ensures copied values match what's displayed by accessing Zustand store
 */
export function directionValueFormatter(params: any): string {
  // Access Zustand store directly to get current trade data
  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);
  const currentTradeData = tradeDataStore.getState().tradeData;
  const thisTrade = currentTradeData.find(
    (trade) => trade.esid == fullTradeData.esid,
  );
  const result = formatDirectionValue(params, thisTrade);
  return result;
}
